const URL = '  https://food-mafia-server.herokuapp.com/api/editProfile';

export const editProfile = (user) =>{
    console.log("Edit profile in react service being called!!")
    fetch(URL+"/"+user._id, {
        method: 'PUT',
        body: JSON.stringify(user),
        headers: {
            'content-type': 'application/json'
        }
    }).then(status => {
        //change this to the service
        window.location.href='/home'
    })
}

export const adminEditProfile = (user) =>{
    console.log("Edit profile in react service being called!!")
    fetch(URL+"/"+user._id, {
        method: 'PUT',
        body: JSON.stringify(user),
        headers: {
            'content-type': 'application/json'
        }
    }).then(status => {
        //change this to the service
        window.location.href='/profile/admin'
    })
}